import axios from 'client';
import * as dto from 'client/dto';

function getFlightTravelVolume(
  model: dto.TravelVolumeRequestModel
): Promise<dto.TravelVolumeListModel> {
  return axios
    .post('/api/travelvolume/flight', model)
    .then(({ data }) => ({ ...data, date: new Date(data.date) }));
}

function getTravelVolume(model: dto.TravelVolumeRequestModel): Promise<dto.TravelVolumeListModel> {
  return axios
    .post('/api/travelvolume', model)
    .then(({ data }) => ({ ...data, date: new Date(data.date) }));
}

function getTravelVolumeMetadata(
  sourceLocationId: number,
  destinationLocationId: number
): Promise<dto.TravelVolumeModel> {
  return axios
    .get('/api/travelvolume/metadata', { params: { sourceLocationId, destinationLocationId } })
    .then(({ data }) => data);
}

function getAggregatedDiseaseRisk(
  model: dto.DiseaseMovementRequestModel
): Promise<dto.DiseaseMovementModel> {
  return axios.post('/api/diseasemovement/aggregated', model).then(({ data }) => data);
}

function getDiseaseRisk(
  model: dto.DiseaseMovementRequestModel
): Promise<dto.DiseaseMovementListModel> {
  return axios.post('/api/diseasemovement', model).then(({ data }) => data);
}

export default {
  getFlightTravelVolume,
  getTravelVolume,
  getTravelVolumeMetadata,
  getAggregatedDiseaseRisk,
  getDiseaseRisk,
};
